// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Carousel_Slider__1Wc-B","title":"Carousel_title__1t_kk","slide":"Carousel_slide__2aKJ9"};